module.exports = __webpack_public_path__ + "img/nodejs02-svgrepo-com.0c6b3fef.svg";